export default "__VITE_ASSET__BBy20C7R__"